import { appendQueryParam } from '@office-start/url-parser-utility';
import { useMemo } from 'react';
import { useOcidValue } from './useOcidValue';
export var useDimeTargetUrl = function (baseUrl, area) {
    var ocid = useOcidValue(area);
    return useMemo(function () {
        return appendQueryParam(baseUrl, 'ocid', ocid);
    }, [baseUrl, ocid]);
};
//# sourceMappingURL=useDimeTargetUrl.js.map